export const Prices = [
  {
    _id: 0,
    name: "₹ 15 to 99",
    array: [15, 99],
  },
  {
    _id: 1,
    name: "₹ 100 to 299",
    array: [100, 299],
  },
  {
    _id: 2,
    name: "₹ 300 to 599",
    array: [300, 599],
  },
  {
    _id: 3,
    name: "₹ 600 to 799",
    array: [600, 799],
  },
  {
    _id: 4,
    name: "₹ 800 to 999",
    array: [800, 999],
  },
  {
    _id: 5,
    name: "₹ 1000 or more",
    array: [1000, 9999],
  },
];
